import { VOFilters } from 'modules/vendorOpportunity';

import { DealPipelineVariables } from '../types';

export function mapVOFiltersToDealPipelineFilters(
  filters: Partial<VOFilters> | null | undefined
): DealPipelineVariables['input']['filters'] {
  return {
    isIncludeClosedDeals: filters?.CLOSED_DEALS?.isIncludeClosedDeals ?? false,
    created: {
      from: filters?.CREATE_DATE_RANGE?.from?.toISOString() ?? new Date().toISOString(),
      to: filters?.CREATE_DATE_RANGE?.to?.toISOString() ?? new Date().toISOString(),
    },
    ...(filters?.SALES_REP?.length ? { salesRep: filters.SALES_REP.map(({ value }) => value) } : {}),
    ...(filters?.SALES_MANAGER?.length ? { salesManager: filters.SALES_MANAGER.map(({ value }) => value) } : {}),
    ...(filters?.FINANCE_MANAGER?.length ? { financeManager: filters.FINANCE_MANAGER.map(({ value }) => value) } : {}),
    ...(filters?.CREDIT_MANAGER?.length ? { creditManager: filters.CREDIT_MANAGER.map(({ value }) => value) } : {}),
  };
}
